import React, { useEffect, useState } from 'react'
import sort from '../resources/icons/sort.svg'
import bitsFetch from '../components/Childs/bitsFetch'
import CopyText from '../components/Childs/CopyText'
import SnackMsg from '../components/Childs/SnackMsg'

export default function LogTable() {
  const [allLogs, setAllLogs] = useState([])
  const [totalLog, setTotalLog] = useState(0)
  const [snack, setSnackbar] = useState({ show: false })
  const [isLoading, setIsLoading] = useState(false)
  const [logPage, setLogPage] = useState(1)
  const [offset, setOffset] = useState(0)
  const count = totalLog / 10
  const lastPage = parseInt(count) === count ? count : parseInt(count) + 1
  const defaultSortByObj = { sortField: 'id', orderType: '' }
  const [sortBy, setSortBy] = useState(defaultSortByObj)
  const headerGroup = [
    { key: 'id', label: '#SL' },
    { key: 'created_at', label: 'Date' },
    { key: 'order_id', label: 'Order ID' },
    { key: 'api_type', label: 'Type' },
    { key: 'response_type', label: 'Response' },
    { key: 'response_obj', label: 'Api Response' }
  ]

  const handleSort = field => {
    let tmp = { ...sortBy }
    const orderGroup = ['', 'ASC', 'DESC']
    tmp.orderType = orderGroup[orderGroup.indexOf(tmp.orderType) + 1] || orderGroup[0]
    if (tmp.orderType) {
      tmp.sortField = field
    } else {
      tmp = defaultSortByObj
    }
    setSortBy(tmp)
  }

  const goToFirst = () => {
    setLogPage(1)
    setOffset(0)
  }

  const goToNext = () => {
    setLogPage(tmp => {
      const nextPage = tmp + 1
      setOffset(prev => prev > 0 ? (prev + 10) : 10)
      return nextPage <= lastPage ? nextPage : tmp
    })
  }

  const goToPrev = () => {
    setLogPage(tmp => {
      const prevPage = tmp - 1
      setOffset(prev => prev - 10 > 0 ? prev - 10 : 0)
      return prevPage > 0 ? prevPage : tmp
    })
  }

  const goToLast = () => {
    setLogPage(lastPage)
    setOffset((lastPage - 1) * 10)
  }

  useEffect(() => {
    setAllLogs([])
    setIsLoading(true)
    bitsFetch({ offset, sortBy }, 'bit_get_log_data')
      .then(result => {
        if (result?.success) {
          setAllLogs(result.data.logs)
          setTotalLog(result.data.total_log.count)
        }
        setIsLoading(false)
      })
  }, [offset, sortBy])

  const showSortIcn = header => {
    if (sortBy.sortField === header.key) {
      if (sortBy.orderType === 'DESC') return <span style={{ fontSize: 20 }}>{String.fromCharCode(9662)}</span>
      else if (sortBy.orderType === 'ASC') return <span style={{ fontSize: 20 }}>{String.fromCharCode(9652)}</span>
    }
    return (<img className="sort-icn" src={sort} />)
  }

  return (
    <div className="btcd-s-wrp">
      <SnackMsg snack={snack} setSnackbar={setSnackbar} />
      <table border="1" className="w-9 f-table">
        <thead className="thead">
          <tr className="tr">
            {headerGroup.map(header => (
              <th className="th" onClick={() => handleSort(header.key)}>{header.label} {showSortIcn(header)}</th>
            ))}
          </tr>
        </thead>
        <tbody className="tbody">
          {
            allLogs?.length ?
              allLogs.map((log, indx) => (
                <tr key={log.id} className="tr">
                  <td className="td">{((logPage - 1) * 10) + (indx + 1)}</td>
                  <td className="td">{log.created_at}</td>
                  <td className="td">{log.order_id}</td>
                  <td className="td">{log.api_type}</td>
                  <td className="td">{log.response_type}</td>
                  <td className="td"><CopyText value={log.response_obj} setSnackbar={setSnackbar} className="field-key-cpy w-6 m-0" /></td>
                </tr>
              ))
              : (
                <tr className="tr">
                  <td className="td" colSpan="6">{isLoading ? 'Loading...' : 'No Log Found!'}</td>
                </tr>
              )
          }
        </tbody>
      </table>

      <div className="btcd-pagination w-9">
        <small>
          Total Response: {totalLog}
        </small>
        <div>
          <button aria-label="Go first" className="icn-btn" type="button" onClick={goToFirst}>
            &laquo;
          </button>
          {' '}
          <button aria-label="Back" className="icn-btn" type="button" onClick={goToPrev} disabled={logPage === 1}>
            &lsaquo;
          </button>
          {' '}
          <button aria-label="Next" className="icn-btn" type="button" onClick={goToNext} disabled={lastPage === logPage}>
            &rsaquo;
          </button>
          {' '}
          <button aria-label="Last" className="icn-btn" type="button" onClick={goToLast}>
            &raquo;
          </button>
          {' '}
          <small>
            &nbsp;Page
            {' '}
            <strong>
              {logPage}
              {' '}
              of
              {' '}
              {totalLog ? lastPage : 0}
              {' '}
            &nbsp;
            </strong>
            {' '}
          </small>
        </div>
      </div>
    </div>
  )
}